query getCategories ($group: [String], $site: [String!]) {
    categories(
        site: $site
        group: $group,
    ) {
        id
        title
        slug
    }
}
